import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Login from './components/Login';
import Register from './components/Register';
import Dashboard from './components/Dashboard';
import Verify from './components/Verify';
import { AuthProvider } from './context/AuthContext';
import { SocketProvider } from './context/SocketContext'; // ← NUEVO
import AuthCallback from './components/AuthCallback';
import Orders from './components/Orders';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import './index.css';

import Home from './components/Home';
import Settings from './components/Settings';
import ChangePassword from './components/ChangePassword';

function App() {
  return (
    <AuthProvider>
      <SocketProvider> {/* ← NUEVO: Envuelve todo para WebSocket */}
        <Router>
          <div className="app">
            <Header />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/verify/:token" element={<Verify />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/change-password" element={<ChangePassword />} />
                <Route path="/auth/callback" element={<AuthCallback />} />
                <Route path="/orders" element={<Orders />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/terms" element={<TermsOfService />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </Router>
      </SocketProvider> {/* ← NUEVO */}
    </AuthProvider>
  );
}

export default App;